import React from "react";

const ValuesIcons = ({ icon, color, label }) => {
  if (!color) {
    color = "#F0FD9D";
  }

  switch (icon) {
    case "cuisine":
      return (
        <svg
          width="248px"
          height="232px"
          viewBox="0 0 248 232"
          id="cuisine-icon"
        >
          <g
            className="value-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              className="value-icon-group"
              transform="translate(-395.000000, -108.000000)"
            >
              <g
                id="cuisine-icon-group"
                transform="translate(395.000000, 104.000000)"
              >
                <path
                  d="M134.000233,138 C127.528303,138 121.693772,134.101034 119.217717,128.121483 C116.741663,122.141932 118.111801,115.259606 122.689134,110.684248 C127.266466,106.108891 134.149383,104.741724 140.127864,107.220359 C146.106345,109.698995 150.002792,115.53521 150,122.007139 C149.984783,130.836137 142.829237,137.988596 134.000233,138 L134.000233,138 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M135.000584,161 C118.821709,161 104.236038,151.253715 98.0452898,136.306118 C91.8545412,121.358522 95.2779748,104.153523 106.719145,92.7143085 C118.160315,81.2750938 135.365898,77.8546015 150.312436,84.0479055 C165.258974,90.2412095 175.002765,104.828546 175,121.007422 C174.973619,143.086445 157.079612,160.977394 135.000584,161 L135.000584,161 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M134.500943,186 C108.412884,186 84.8937523,170.284565 74.9109267,146.182075 C64.928101,122.079585 70.4476267,94.3368509 88.8956533,75.8907905 C107.34368,57.4447301 135.087002,51.9281615 159.188427,61.9135563 C183.289853,71.8989512 199.002781,95.4197579 199,121.507817 C198.962102,157.11284 170.10597,185.965898 134.500943,186 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M135.496573,210 C86.6447493,209.943351 47.0566486,170.355251 47,121.503427 C47,72.7011267 86.7011267,33 135.496573,33 C184.353746,33.0528799 223.94712,72.6462541 224,121.503427 C224,170.298873 184.298873,210 135.496573,210 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M134,235 C71.6940289,235 21,184.311301 21,122.003436 C21,59.6955702 71.6940289,9 134,9 C196.305971,9 247,59.688699 247,122.003436 C247,184.318172 196.312842,235 134,235 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                {label && (
                  <text
                    className="icon-text"
                    fontFamily="Apercu-Regular, Apercu"
                    fontSize="18"
                    fontWeight="normal"
                    fill={color}
                  >
                    <tspan x="0.43" y="18">
                      Cuisine
                    </tspan>
                  </text>
                )}
              </g>
            </g>
          </g>
        </svg>
      );
    case "experience":
      return (
        <svg
          width="244px"
          height="244px"
          viewBox="0 0 244 244"
          id="experience-icon"
        >
          <g
            className="value-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              className="value-icon-group"
              transform="translate(-743.000000, -104.000000)"
            >
              <g
                id="experience-icon-group"
                transform="translate(744.786797, 106.000000)"
              >
                <polygon
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                  points="119.996592 240 71.879349 168.114526 0 120 71.879349 71.878657 119.989775 0 168.665966 72.4308357 240 119.993183 168.113835 168.114526"
                ></polygon>
                <polygon
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                  points="121.003403 214 82.8931552 157.102769 26 118.989791 82.8931552 80.8768134 120.969376 24 159.515169 81.394061 216 119.044238 159.100039 157.157216"
                ></polygon>
                <polygon
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                  points="120.496629 189 92.629202 147.349913 51 119.479765 92.629202 91.6298525 120.489886 50 148.667475 91.9333754 190 119.506745 148.364055 147.383637"
                ></polygon>
                <polygon
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                  points="120.489753 165 102.250131 137.751258 75 119.503417 102.250131 101.255576 120.482922 74 138.927483 101.433271 166 119.489748 138.729375 137.751258"
                ></polygon>
                <polygon
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                  points="120.96862 142 112.551884 129.429332 100 121.006984 112.551884 112.570668 120.961647 100 129.448116 112.605587 142 120.986033 129.448116 129.415364"
                ></polygon>
                {label && (
                  <text
                    className="icon-text"
                    transform="translate(192.072853, 192.478445) rotate(-45.000000) translate(-192.072853, -192.478445) "
                    fontFamily="Apercu-Regular, Apercu"
                    fontSize="18"
                    fontWeight="normal"
                    fill={color}
                  >
                    <tspan x="147.711853" y="199.478445">
                      Experience
                    </tspan>
                  </text>
                )}
              </g>
            </g>
          </g>
        </svg>
      );
    case "story":
      return (
        <svg width="232px" height="228px" viewBox="0 0 232 228" id="story-icon">
          <g
            className="value-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              className="value-icon-group"
              transform="translate(-1102.000000, -112.000000)"
            >
              <g
                id="story-icon-group"
                transform="translate(1103.000000, 113.000000)"
              >
                <path
                  d="M153.046651,226 C124.537935,226.026044 101.116588,203.49427 100.038562,175.005206 C98.9605365,146.516142 120.612139,122.278721 149.041295,120.15015 C177.470452,118.021579 202.489697,138.764621 205.665806,167.096596 C208.841915,195.428571 189.036743,221.196836 160.841984,225.416319 C158.26145,225.802508 155.65592,225.997592 153.046651,226 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M115.945981,106 C92.1712821,105.974626 71.3224962,90.1192512 64.9461811,67.2144374 C58.569866,44.3096237 68.2265907,19.9612019 88.5682291,7.65391262 C108.909868,-4.65337667 134.957913,-1.90739025 152.286332,14.3710787 C169.614751,30.6495476 173.982506,56.4764308 162.97063,77.5481804 C153.873054,95.1021627 135.716425,106.087457 115.945981,106 L115.945981,106 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M75.0790852,224.986564 C50.4497653,225 29.0511335,208.068908 23.4135342,184.108123 C17.7759349,160.147337 29.3825298,135.460334 51.4368737,124.50302 L51.4368737,124.50302 C71.0342358,114.806843 94.5774341,118.126458 110.725577,132.862788 C126.873719,147.599118 132.315388,170.730259 124.429301,191.113809 C116.543215,211.49736 96.9465315,224.953368 75.0790852,225 L75.0790852,224.986564 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M177.431427,152 C174.49884,151.99561 171.571757,151.743542 168.680803,151.246419 L168.680803,151.246419 C140.94551,146.473544 121.868401,120.474989 125.426535,92.2988864 C128.984669,64.1227841 153.912845,43.7879973 181.947154,46.1930362 C209.981462,48.598075 231.153461,72.8877556 229.951247,101.26597 C228.749033,129.644185 205.600089,152.020204 177.46475,152 L177.431427,152 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M52.9535372,150 C27.6213703,149.976705 5.8476017,132.029282 0.989070684,107.167251 C-3.86946033,82.3052191 9.54590018,57.4810715 33.0056712,47.9228628 C56.4654423,38.3646542 83.4092644,46.7452702 97.3087952,67.9237294 C111.208326,89.1021886 108.17666,117.156084 90.0735332,134.876114 C80.1649171,144.594221 66.8323179,150.026318 52.9535372,150 L52.9535372,150 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                {label && (
                  <text
                    className="icon-text"
                    fontFamily="Apercu-Regular, Apercu"
                    fontSize="18"
                    fontWeight="normal"
                    fill={color}
                  >
                    <tspan x="95.809" y="41">
                      Story
                    </tspan>
                  </text>
                )}
              </g>
            </g>
          </g>
        </svg>
      );
    case "sustainability":
      return (
        <svg
          width="201px"
          height="228px"
          viewBox="0 0 201 228"
          id="sustainability-icon"
        >
          <g
            className="value-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              className="value-icon-group"
              transform="translate(-1451.000000, -112.000000)"
            >
              <g
                id="sustainability-icon-group"
                transform="translate(1450.000000, 113.000000)"
              >
                <path
                  d="M112.396623,26 C78.4882044,26 51,53.5916473 51,87.627669 C51,121.663691 78.4882044,149.255338 112.396623,149.255338 L112.00705,149.307477 C116.429321,149.409927 120.560056,147.100378 122.801181,143.272334 C125.042306,139.44429 125.042306,134.69817 122.801181,130.870126 C120.560056,127.042081 116.429321,124.732532 112.00705,124.834983 L112.00705,124.776327 C98.8253226,124.952632 86.5690425,117.9948 79.9269533,106.56461 C73.2848642,95.1344205 73.2848642,81.0007542 79.9269533,69.5705643 C86.5690425,58.1403744 98.8253226,51.1825431 112.00705,51.3588473 L112.00705,51.3588473 C143.556655,50.6349001 173.023303,67.1157752 189.009987,94.4270562 C204.996671,121.738337 204.996671,155.597604 189.009987,182.908885 C173.023303,210.220166 143.556655,226.701041 112.00705,225.977094"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M113.154693,0 C65.7922163,1.15840297 28,39.9154427 28,87.328666 C28,134.741889 65.7922163,173.498929 113.154693,174.657332 L113.154693,174.696446 C133.419809,174.696446 149.84793,158.255632 149.84793,137.974859 C149.84793,117.694087 133.419809,101.253273 113.154693,101.253273 L113.154693,101.188083 C106.398456,101.188083 100.921443,95.7068382 100.921443,88.9453807 C100.921443,82.1839231 106.398456,76.7026787 113.154693,76.7026787 L112.763855,76.7026787 C134.922151,76.4746381 155.495465,88.1743656 166.640913,107.341734 C177.786362,126.509103 177.786362,150.190302 166.640913,169.357671 C155.495465,188.525039 134.922151,200.224767 112.763855,199.996726"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                {label && (
                  <text
                    className="icon-text"
                    fontFamily="Apercu-Regular, Apercu"
                    fontSize="18"
                    fontWeight="normal"
                    fill={color}
                  >
                    <tspan x="0.691" y="218">
                      Sustainability
                    </tspan>
                  </text>
                )}
              </g>
            </g>
          </g>
        </svg>
      );
    case "diversity":
      return (
        <svg
          width="209px"
          height="209px"
          viewBox="0 0 209 209"
          id="diversity-icon"
        >
          <g
            className="value-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              className="value-icon-group"
              transform="translate(-1777.000000, -122.000000)"
            >
              <g
                id="diversity-icon-group"
                transform="translate(1778.000000, 123.000000)"
              >
                <path
                  d="M0,0.17882511 C0,57.2854287 46.3103483,103.579478 103.437058,103.579478 C160.561982,103.579478 207,57.1048186 207,0 C179.571794,0 153.26833,10.8983089 133.88236,30.2948471 C114.49639,49.6913852 103.617833,75.9953577 103.642448,103.413899 C103.642448,160.518718 149.702813,207 206.827737,207 C206.428996,150.230117 160.307048,104.404436 103.515803,104.351693 C46.7245575,104.298951 0.517512217,150.038885 0.0132509682,206.807929 L0.152386134,206.807929 C27.587286,206.813199 53.9003278,195.922257 73.3015957,176.531544 C92.7028635,157.140831 103.602696,130.839144 103.602695,103.413899 C103.602695,46.3289499 57.0917966,0.0463620657 0.00662548411,0 L0,0.17882511 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                <path
                  d="M207,103.503315 C179.601597,103.501556 153.32476,114.404864 133.950543,133.814448 C114.576326,153.224032 103.691899,179.549824 103.691899,207 L103.308101,207 C103.308101,179.549824 92.4236743,153.224032 73.0494571,133.814448 C53.6752398,114.404864 27.3984033,103.501556 0,103.503315 C57.0554884,103.503315 103.308101,57.1633024 103.308101,0 L103.691899,0 C103.691899,57.1633024 149.944512,103.503315 207,103.503315 Z"
                  className="value-icon-path"
                  stroke={color}
                  strokeWidth="2"
                ></path>
                {label && (
                  <text
                    className="icon-text"
                    transform="translate(168.000000, 165.000000) rotate(45.000000) translate(-168.000000, -165.000000) "
                    fontFamily="Apercu-Regular, Apercu"
                    fontSize="18"
                    fontWeight="normal"
                    fill={color}
                  >
                    <tspan x="134.385" y="172">
                      Diversity
                    </tspan>
                  </text>
                )}
              </g>
            </g>
          </g>
        </svg>
      );
    default:
      return null;
  }
};

export default ValuesIcons;
